"use client"

import { useState, useEffect, useRef } from "react"
import { Parallax } from "react-scroll-parallax"
import "./ServicesSection.css"
import sideImageLeft from "../../assets/sombra8.png"
import sideImageRight from "../../assets/sombra_3.jpg"

function ServicesSection() {
  const [showSideImages, setShowSideImages] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const [contentLoaded, setContentLoaded] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const sectionRef = useRef(null)

  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    // Check on initial load
    checkMobile()

    // Add resize listener
    window.addEventListener("resize", checkMobile)

    return () => {
      window.removeEventListener("resize", checkMobile)
    }
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowSideImages(true)
      } else {
        setShowSideImages(false)
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries
        setIsVisible(entry.isIntersecting)

        // When section becomes visible, set a timer to allow scrolling after content is loaded
        if (entry.isIntersecting) {
          // On mobile, show side images immediately
          if (isMobile) {
            setShowSideImages(true)
          }

          setTimeout(() => {
            setContentLoaded(true)
          }, 1500) // Wait for animations to complete
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.3,
      },
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current)
      }
    }
  }, [isMobile])

  return (
    <section className={`services-container ${contentLoaded ? "content-loaded" : ""}`} ref={sectionRef}>
      {isMobile ? (
        // Mobile version - no Parallax for side images but with proper order
        <div className={`side-image left ${showSideImages ? "visible" : ""}`}>
          <img src={sideImageLeft || "/placeholder.svg"} alt="Side Left" />
        </div>
      ) : (
        // Desktop version - with Parallax
        <Parallax
          className={`side-image left ${showSideImages ? "visible" : ""}`}
          translateX={[-100, 0]}
          opacity={[0, 1]}
        >
          <img src={sideImageLeft || "/placeholder.svg"} alt="Side Left" />
        </Parallax>
      )}

      <div className={`service-column first ${isVisible ? "animate" : ""}`}>
        <h2 className="service-title">FACIAL</h2>
        <div className="title-line"></div>
        <a href="/tratamientos/facial" className="circle-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 12H19M19 12L12 5M19 12L12 19"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
        <p className="service-description">
          Ofrecemos protocolos personalizados para realizar y cuidar cada detalle de tu rostro, utilizando la más alta
          tecnología adaptada a las necesidades de tu piel.
        </p>
        <a href="/tratamientos/facial" className="ver-mas">
          VER MÁS
        </a>
      </div>

      <div className={`service-column second ${isVisible ? "animate" : ""}`}>
        <h2 className="service-title">CORPORAL</h2>
        <div className="title-line"></div>
        <a href="/tratamientos/corporal" className="circle-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 12H19M19 12L12 5M19 12L12 19"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
        <p className="service-description">
          Brindamos asesoría personalizada para encontrar el tratamiento ideal, asegurando resultados positivos que
          mejoran tanto tu apariencia como tu autoestima.
        </p>
        <a href="/tratamientos/corporal" className="ver-mas">
          VER MÁS
        </a>
      </div>

      <div className={`service-column third ${isVisible ? "animate" : ""}`}>
        <h2 className="service-title">CAPILAR</h2>
        <div className="title-line"></div>
        <a href="/tratamientos/capilar" className="circle-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 12H19M19 12L12 5M19 12L12 19"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
        <p className="service-description">
          Ofrecemos tratamientos innovadores con tecnología de punta para combatir la pérdida de cabello en hombres y
          mujeres.
        </p>
        <a href="/tratamientos/capilar" className="ver-mas">
          VER MÁS
        </a>
      </div>

      {isMobile ? (
        // Mobile version - no Parallax for side images
        <div className={`side-image right ${showSideImages ? "visible" : ""}`}>
          <img src={sideImageRight || "/placeholder.svg"} alt="Side Right" />
        </div>
      ) : (
        // Desktop version - with Parallax
        <Parallax className={`side-image right ${showSideImages ? "visible" : ""}`} translateX={[100, 0]}>
          <img src={sideImageRight || "/placeholder.svg"} alt="Side Right" />
        </Parallax>
      )}
    </section>
  )
}

export default ServicesSection